export function formatPhoneNumber(value: string): string {
  if (!value) {
    return '';
  }

  // Strip all non-digits
  const cleaned = value.replace(/\D/g, '');

  // Remove leading '1' if it's a country code
  const phone =
    cleaned.length === 11 && cleaned.startsWith('1')
      ? cleaned.slice(1)
      : cleaned;

  if (phone.length <= 3) {
    return `(${phone}`;
  } else if (phone.length <= 6) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
  } else if (phone.length <= 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }

  return value; // fallback if number is longer than expected
}

export function normalFormatPhoneNumber(value: string): string {
  if (!value) {
    return '';
  }
  return value.replace(/\D+/g, '');
}

export function unformatPhoneNumberAndAddCountryCode(phone: string): string {
  if (!phone) {
    return '';
  }
  const digitsOnly = phone.replace(/\D/g, ''); // Remove all non-digit characters

  if (digitsOnly.startsWith('1') && digitsOnly.length === 11) {
    return `+${digitsOnly}`;
  }

  if (digitsOnly.length === 10) {
    return `+1${digitsOnly}`;
  }

  // If it's already in E.164 format or doesn't match standard patterns
  return phone.startsWith('+') ? phone : `+${digitsOnly}`;
}
